import { render } from "./IdleModal.vue?vue&type=template&id=5483a8f4&ts=true"
import script from "./IdleModal.vue?vue&type=script&lang=ts"
export * from "./IdleModal.vue?vue&type=script&lang=ts"

import "./IdleModal.vue?vue&type=style&index=0&id=5483a8f4&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__